import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ScrollAdapterComponent } from '@frontend/sports/common/core/feature/scroll-adapter';
import { LinkDirective, SportsThemedPillsDirective } from '@frontend/sports/common/ui/sports-themed-pills';
import { DsPill } from '@frontend/ui/pill';
import { SpeculativeLinkDirective } from '@frontend/vanilla/features/speculative-link';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';
import { EffectsModule } from '@ngrx/effects';

import { BannerComponent } from '../banner/banner.component';
import { ErrorComponent } from '../common/error/error.component';
import { HeadingComponent } from '../common/heading.component';
import { ItemComponent } from '../common/item/item.component';
import { DirectivesModule } from '../directives/directives.module';
import { EventListSharedModule } from '../event-list-shared/event-list-shared.module';
import { FavouritesModule } from '../favourites/favourites.module';
import { GridModule } from '../grid/grid.module';
import { SkeletonModule } from '../skeleton-ui/skeleton.module';
import { TabBarModule } from '../tab-bar/tab-bar.module';
import { LiveBreadcrumbsResolver } from './live-breadcrumbs.resolver';
import { LiveEventListComponent } from './live-event-list.component';
import { LiveEventListResolver } from './live-event-list.resolver';
import { LiveFavouritesOverviewComponent } from './live-favourites-overview.component';
import { LiveGridFooterComponent } from './live-grid-footer.component';
import { LiveGridEffects } from './live-grid.epic';
import { LiveRootGuard, LiveSportGuard } from './live-guard.service';
import { LiveHistoryService } from './live-history.service';
import { LiveOverviewSubNavigationResolve } from './live-overview-subnavigation.service';
import { LiveOverviewComponent } from './live-overview.component';
import { LiveRoutingModule } from './live-routing.module';
import { LiveSportListComponent } from './live-sport-list.component';
import { LiveUpcomingListComponent } from './live-upcoming-list.component';
import { LiveComponent } from './live.component';

@NgModule({
    imports: [
        BannerComponent,
        CommonModule,
        DirectivesModule,
        FavouritesModule,
        GridModule,
        EffectsModule.forFeature([LiveGridEffects]),
        LiveRoutingModule,
        EventListSharedModule,
        TabBarModule,
        SkeletonModule,
        ErrorComponent,
        ItemComponent,
        HeadingComponent,
        DsPill,
        ScrollAdapterComponent,
        LinkDirective,
        SpeculativeLinkDirective,
        IconCustomComponent,
        SportsThemedPillsDirective,
    ],
    declarations: [
        LiveComponent,
        LiveEventListComponent,
        LiveFavouritesOverviewComponent,
        LiveGridFooterComponent,
        LiveOverviewComponent,
        LiveSportListComponent,
        LiveUpcomingListComponent,
    ],
    exports: [LiveComponent, LiveEventListComponent, LiveFavouritesOverviewComponent, LiveOverviewComponent, LiveSportListComponent],
    providers: [LiveBreadcrumbsResolver, LiveEventListResolver, LiveHistoryService, LiveOverviewSubNavigationResolve, LiveRootGuard, LiveSportGuard],
})
export class LiveModule {}
